<template>

</template>

<script>

// Firebase
import firebase from '../modules/firebase'

export default {
  // data () {
  //   return {
  //   }
  // },
  beforeMount: function () {
    firebase.auth().signOut()
    this.$router.push({name: 'Login'})
  }
}
</script>



// WEBPACK FOOTER //
// Logout.vue?7e9ae310